// extracted by mini-css-extract-plugin
export default {"requiredAsterisk":"SearchFilterBar-module__requiredAsterisk__CFCXt"};